import React from "react";
import type { LaunchableContentTabProps } from "../tabs/LaunchableContentTab";
import NemoClawSkin from "./nemoclaw/NemoClawSkin";
import { DefectImageSkin } from "./physical-ai/defect-image/DefectImageSkin";
import { SensorCarlineSkin } from "./physical-ai/sensor-carline/SensorCarlineSkin";
import { VideoAugmentationSkin } from "./physical-ai/video-augmentation/VideoAugmentationSkin";
import { LAUNCHABLE_SKIN, type LaunchableSkin } from "./registry";

interface SkinContentProps extends LaunchableContentTabProps {
  skin: LaunchableSkin | null;
}

export const SkinContent: React.FC<SkinContentProps> = ({ skin, ...props }) => {
  switch (skin) {
    case LAUNCHABLE_SKIN.NEMOCLAW:
      return <NemoClawSkin {...props} />;
    case LAUNCHABLE_SKIN.PHYSICAL_AI_SENSOR_CARLINE:
      return <SensorCarlineSkin {...props} />;
    case LAUNCHABLE_SKIN.PHYSICAL_AI_DEFECT_IMAGE:
      return <DefectImageSkin {...props} />;
    case LAUNCHABLE_SKIN.PHYSICAL_AI_VIDEO_AUGMENTATION:
      return <VideoAugmentationSkin {...props} />;
    default:
      return null;
  }
};
